import { render, staticRenderFns } from "./LayoutThirdParty.vue?vue&type=template&id=4cf3c5ea&"
import script from "./LayoutThirdParty.vue?vue&type=script&lang=ts&"
export * from "./LayoutThirdParty.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutThirdParty.vue?vue&type=style&index=0&id=4cf3c5ea&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf3c5ea')) {
      api.createRecord('4cf3c5ea', component.options)
    } else {
      api.reload('4cf3c5ea', component.options)
    }
    module.hot.accept("./LayoutThirdParty.vue?vue&type=template&id=4cf3c5ea&", function () {
      api.rerender('4cf3c5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/LayoutThirdParty.vue"
export default component.exports